import React from "react";
import "./Analytics.css";

const Analytics: React.FC = () => {
  return (
    <div className="home-page w-full ">
      <div className="content flex justify-center items-center w-full h-dvh">
        <div className="text-center">
          <h1>Welcome to the Home Page</h1>
          <p>This is the landing page after a successful login.</p>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
